// Units list — Session C migration to the FwTable pattern.
// CSV sample/import ported verbatim from AgTable (same endpoint + the same
// unitName/locality-ObjectId validation).
import { Fragment, useRef } from "react";
import Papa from "papaparse";

import ModuleListPage from "elements/Table/ModuleListPage";
import { api, common } from "includes";

const isValidObjectId = (id: string) => /^[0-9a-fA-F]{24}$/.test(id);

function UnitCsvButtons({ reload }: { reload: () => void }) {
  const fileInputRef = useRef<HTMLInputElement>(null);

  const downloadSampleCSV = () => {
    const sampleData = {
      unitName: "",
      locality:
        "Hint: The locality field should be populated with locality IDs only, rather than names. USA - 6811b415c2d8f5fae184fb96 | New York City - 6811b415c2d8f5fae184fb94 | Long Island - 6811b415c2d8f5fae184fb92",
    };
    const csvContent = Papa.unparse([sampleData]);
    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.setAttribute("href", url);
    link.setAttribute("download", "unit_sample.csv");
    link.click();
  };

  const handleFileChange = (e: any) => {
    const file = e.target.files[0];
    if (!file) return;

    Papa.parse(file, {
      header: true,
      skipEmptyLines: true,
      complete: function (results: any) {
        const cleanedRecords = results.data
          .map((record: any) => {
            const cleaned: any = {};
            for (let key in record) {
              const value = record[key]?.toString().trim();
              if (value) cleaned[key] = value;
            }
            delete cleaned.createdAt;
            if (
              !cleaned.unitName ||
              !cleaned.locality ||
              !isValidObjectId(cleaned.locality)
            ) {
              return null;
            }
            return cleaned;
          })
          .filter((rec: any) => rec !== null);

        if (cleanedRecords.length === 0) {
          common.notify("W", "No valid records found in the file.");
          return;
        }

        api.call(
          {
            url: "admin/prefilled-locality-unit/bulk-insert",
            method: "POST",
            auth: "token",
            body: { records: cleanedRecords },
          },
          (res: any) => {
            if (res.status === 200) {
              common.notify("S", "Bulk records inserted successfully.");
              reload();
            } else {
              common.notify("E", "Bulk insert failed.");
            }
          }
        );
        e.target.value = null;
      },
      error: function (error: any) {
        common.notify("E", "CSV Parsing Error: " + error.message);
      },
    });
  };

  return (
    <Fragment>
      <button
        type="button"
        className="btn btn-secondary btn-sm"
        onClick={downloadSampleCSV}
      >
        <i className="ri-download-line" /> Sample CSV
      </button>
      <input
        type="file"
        ref={fileInputRef}
        onChange={handleFileChange}
        accept=".csv"
        style={{ display: "none" }}
      />
      <button
        type="button"
        className="btn btn-secondary btn-sm"
        onClick={() => fileInputRef.current?.click()}
      >
        <i className="ri-upload-line" /> Upload CSV
      </button>
    </Fragment>
  );
}

export default function UnitList() {
  return (
    <ModuleListPage
      module="unit"
      title="Units"
      api="admin/prefilled-locality-unit"
      url="unit"
      columnsKey="unit"
      quickKey="unitName"
      quickPlaceholder="Filter by unit name…"
      localityFilter
      perms={["ulr", "ulc", "ulu", "uld"]}
      extraToolbar={(reload) => <UnitCsvButtons reload={reload} />}
    />
  );
}
